import * as CreditCardAction from "./CreditCardAction";

export default function creditCardReducer(state = {}, action) {
    switch (action.type) {
        case CreditCardAction.CREDIT_CARD_CUSTOMER_FINISHED:
            if (action.payload.errors) {
                return {
                    ...state,
                    customerError: {
                        ...action.payload
                    }
                };
            } else {
                return {
                    ...state,
                    customer: {
                        ...action.payload
                    }
                };
            }

        case CreditCardAction.CREDIT_CARD_PAYMENT_FINISHED:
            if (action.payload.errors) {
                return {
                    ...state,
                    paymentError: {
                        ...action.payload
                    }
                };
            } else {
                return {
                    ...state,
                    charge: {
                        ...action.payload
                    }
                };
            }

        case CreditCardAction.PAYMENT_STATUS_CHECK_FINISHED:
            if (action.payload.errors) {
                return {
                    ...state,
                    paymentStatusError: {
                        ...action.payload
                    }
                };
            } else {
                return {
                    ...state,
                    paymentStatus: {
                        ...action.payload
                    }
                };
            }
 
        default:
            return state;
    }
}